import React from "react";
import { useAuth } from "../../contexts/AuthContext";

// Shown when the GET /workspaces request itself fails (network error, 5xx,
// etc.) — distinct from NoWorkspaceScreen, which is for the confirmed case of
// zero live workspaces. Conflating the two would tell users who DO have
// workspaces (owners get a stale "create your first workspace" form, members
// get told they have no access) that their workspace disappeared, when the
// real problem is just a failed request.
const WorkspacesLoadError = () => {
  const { fetchWorkspaces, removeToken } = useAuth();

  const handleRetry = () => {
    fetchWorkspaces();
  };

  const handleLogout = () => {
    removeToken();
    window.location.assign("/login");
  };

  return (
    <div className="flex h-svh items-center justify-center bg-background p-4">
      <div className="w-full max-w-sm rounded-xl border border-border bg-card p-6 shadow-sm">
        <h1 className="text-lg font-semibold text-foreground">Something went wrong</h1>
        <p className="mb-4 mt-1 text-sm text-muted-foreground">
          We couldn't load your workspaces.
        </p>
        <button
          type="button"
          onClick={handleRetry}
          className="w-full rounded-md bg-primary px-3 py-2 text-sm font-medium text-primary-foreground"
        >
          Try again
        </button>
        <button
          type="button"
          onClick={handleLogout}
          className="mt-3 w-full rounded-md border border-border px-3 py-2 text-sm text-foreground"
        >
          Log out
        </button>
      </div>
    </div>
  );
};

export default WorkspacesLoadError;
